import React from "react";
import { Modal, Row, Col, ModalProps } from "react-bootstrap";

import { CloseButton } from "components";
import { TablePagination } from "components/tablePagination";
import { DealNote } from "types";

import { NoteDiffList } from "./noteDiffList";

import styles from "./notes.module.scss";

type NoteListModalProps = {
	show: boolean;
	onHide: () => void;
	title?: string;
	dialogAs?: ModalProps["dialogAs"];
	notes?: DealNote[];
	backdrop?: boolean;
	loading: boolean;
	handlePageChange: (page: number) => void;
	page: number;
	count: number;
};

export const NoteListModal = ({
	show,
	onHide,
	title,
	notes = [],
	dialogAs,
	backdrop,
	loading = false,
	handlePageChange,
	page,
	count,
}: NoteListModalProps) => (
	<Modal
		show={show}
		onHide={onHide}
		animation={false}
		centered
		dialogAs={dialogAs}
		backdrop={backdrop}
		scrollable
		id="noteListModal"
		className={styles.modalSizeFix}
	>
		<Modal.Header>
			<Modal.Title className="text-center">{title}</Modal.Title>
			<CloseButton onClick={onHide} />
		</Modal.Header>
		<Modal.Body style={{ maxHeight: "75vh" }}>
			<Row
				style={{
					maxHeight: "calc(75vh - 90px)",
					overflowY: "auto",
				}}
			>
				<Col md={{ span: 6, offset: 3 }}>
					{notes.length > 0 && (
						<NoteDiffList
							loading={loading}
							notes={notes}
							className="mb-4"
						/>
					)}
				</Col>
			</Row>
		</Modal.Body>
		<Modal.Footer className="p-0">
			{count > 50 && (
				<TablePagination
					wrapperClassName="w-100"
					handlePageChange={handlePageChange}
					page={page}
					count={count}
				/>
			)}
		</Modal.Footer>
	</Modal>
);
